import React, { useEffect, useState } from "react";
import Sidebar from "../../component/home/sidebar";
import SwitchInputField from "../../component/switch-input-field";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";
import LimitAlert from "../../component/Alert/LimitAlert";
// Import redux
import { useDispatch, useSelector } from "react-redux";
import {
  notificationData,
  updateNotificationSetting,
} from "../../redux/actions/emailNotification";

function EmailNotification() {
  const defaultConfigs = [
    {
      title: "New To Do is assigned",
      checked: false,
    },
    {
      title: "To Do reminder",
      checked: false,
    },
    {
      title: "To Do overdue reminder",
      checked: false,
    },
    {
      title: "To Do performed",
      checked: false,
    },
    {
      title: "To Do request",
      checked: false,
    },
  ];

  const [configs, setConfigs] = useState(defaultConfigs);
  const [update, setUpdate] = useState(0);

  const dispatch = useDispatch();
  const { planDetail } = useSelector((state) => state.booking);
  const {emailNotificationData} = useSelector(state => state.emailNotification)

  const handleCheck = (index) => {
    const newConfigs = [...configs];
    newConfigs[index].checked = !newConfigs[index].checked;
    setConfigs(newConfigs);
  };

  const getEmailNotificationData = () => {
    const request = {
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(notificationData(request));
  };

  useEffect(() => {
    getEmailNotificationData();
  }, [update]);

  useEffect(() => {
    if (emailNotificationData) {
      const newConfigs = [...configs];
      newConfigs[0].checked = emailNotificationData.todo_assign;
      newConfigs[1].checked = emailNotificationData.todo_reminder;
      newConfigs[2].checked = emailNotificationData.todo_overdue_reminder;
      newConfigs[3].checked = emailNotificationData.todo_performed;
      newConfigs[4].checked = emailNotificationData.todo_request;
      setConfigs(newConfigs);
    }
  }, [emailNotificationData]);

  const handleSubmit = () => {
    const payload = {
      todo_assign: configs[0].checked,
      todo_reminder: configs[1].checked,
      todo_overdue_reminder: configs[2].checked,
      todo_performed: configs[3].checked,
      todo_request: configs[4].checked,
    };

    const request = {
      data: payload,
      onSuccess: () => {
        setUpdate(update + 1);
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Email notifications setting has been updated successfully.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(updateNotificationSetting(request));
  };

  return (
    <>
      {/* <div className="sm:mx-6 lg:mx-8">{planDetail && <LimitAlert />}</div> */}
      <div className="mt-4 sm:mx-6 lg:mx-8">
        <div className="flex flex-col md:flex-row" style={{ height: 'calc(100vh - 176px)'}}>
          <Sidebar />
          <div className="flex-auto p-5 bg-white max-h-full">
            <div className="mb-5">
              <h4 className="text-xl font-bold leading-8 mb-4">
                Email Notification
              </h4>
            </div>
            <ul>
              {configs.map((item, index) => (
                <SwitchInputField
                  key={index}
                  tag="li"
                  index={index}
                  description={item.title}
                  checked={item.checked}
                  wrapperCSS="text-[#475569] font-medium leading-[22px]"
                  onCheck={() => handleCheck(index)}
                />
              ))}
            </ul>
            <div className="flex justify-end py-4">
              <button
                type="button"
                className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
                onClick={() => handleSubmit()}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmailNotification;

EmailNotification.auth = { path: "/notifications", role: ["super-admin"] };
